import React from "react";
import { Outlet } from "react-router-dom";
import { AuthProvider } from "../../context/authContext";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const BaseLayout: React.FC = (props) => {
    return (
        <div className="font-roboto">
            <AuthProvider>
                <Outlet />
                <ToastContainer
                    position="bottom-left"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    draggable
                    pauseOnFocusLoss={false}
                    pauseOnHover
                    theme="light"
                    style={{width:'auto'}}
                />
            </AuthProvider>
        </div>
    );
}

export default BaseLayout;